import { useEffect, useState } from 'react'
import { Box, Heading, Text, SimpleGrid, Flex, Spinner } from '@chakra-ui/react'
import { Users, BookOpen, DollarSign, TrendingUp } from 'lucide-react'
import axios from 'axios'

function StatCard({ label, value, sub, icon: Icon, color }) {
  return (
    <Box bg="white" borderRadius="12px" border="1px solid #E2E2E2" p={5}>
      <Flex justify="space-between" align="flex-start">
        <Box>
          <Text fontSize="12px" color="gray.500" textTransform="uppercase" letterSpacing="0.8px" mb={1}>{label}</Text>
          <Text fontSize="28px" fontWeight="600" fontFamily="Georgia, serif" color="brand.darkBlue">{value}</Text>
          {sub && <Text fontSize="12px" color="gray.400" mt={1}>{sub}</Text>}
        </Box>
        <Box bg={color + '15'} p={2.5} borderRadius="8px"><Icon size={20} color={color} /></Box>
      </Flex>
    </Box>
  )
}

export default function AdminDashboard() {
  const [data, setData] = useState(null)
  useEffect(() => { axios.get('/api/admin/dashboard').then(r => setData(r.data)).catch(() => {}) }, [])
  if (!data) return <Box p={8}><Spinner color="brand.orange" /></Box>
  return (
    <Box p={8}>
      <Heading size="lg" fontFamily="Georgia, serif" color="brand.darkBlue" mb={2}>Dashboard</Heading>
      <Text fontSize="14px" color="gray.500" mb={8}>WriteMills platform overview</Text>
      <SimpleGrid columns={{ base: 2, lg: 4 }} spacing={4} mb={8}>
        <StatCard label="Total Users" value={data.users.total} sub={'+' + data.users.new_30d + ' this month'} icon={Users} color="#0A1F44" />
        <StatCard label="Subscriptions" value={data.subscriptions.active} sub={data.subscriptions.platform_authors + ' platform + ' + data.subscriptions.external + ' external'} icon={TrendingUp} color="#1A6B2A" />
        <StatCard label="MRR" value={'$' + data.revenue.mrr} sub={'$' + data.revenue.arr + ' ARR'} icon={DollarSign} color="#E87300" />
        <StatCard label="Books Written" value={data.books.total} sub={data.books.completed + ' completed'} icon={BookOpen} color="#0A1F44" />
      </SimpleGrid>
    </Box>
  )
}
